import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
import { Button } from '../../../../../../../../components/Button';
import { ButtonRow } from '../../../../../../../../components/ButtonRow';
import { MaterialIcon } from '../../../../../../../../components/MaterialIcon';
import { Tooltip } from '../../../../../../../../components/Tooltip';
import { NewPredicateButton } from './NewPredicateButton';
import { IconMenuOrder } from '../../../../../../../../components/SvgIcons/IconMenuOrder';

// Context
import { RuleEditorContext } from '../context';

export const ActionsContainer = styled.div`
    z-index: 1;
    width: 12rem;
`;

const ButtonIcon = styled(MaterialIcon)`
    margin: 0 !important;
`;

const DraggableButton = styled(Button)`
    cursor: ${({ isdragging }) => (isdragging === 'true' ? 'grabbing !important' : 'grab')};
`;

const InvisibleButton = styled(Button)`
    pointer-events: none;
    opacity: 0;
`;

const borderColor = 'hsl(0,0%,80%)';

const CompactButtonRow = styled(ButtonRow)`
    z-index: 1;
    border-radius: 25px;
    overflow: hidden;
    border: 1px solid ${borderColor};
    background: #fff;
    float: right;
    width: fit-content;
    button {
        border: none;
        border-right: 1px solid ${borderColor};
    }
    button:first-child {
        border-left: none;
        padding-left: 14px;
    }
    button:last-child {
        border-right: none;
        padding-right: 14px;
    }
`;

const ICON_SIZE = 18;

const ActionButtonTooltip = ({ title, disabled, children }) => (
    <Tooltip
        transitionFlip={false}
        followCursor={false}
        title={title}
        position="top"
        trigger="mouseenter"
        delay={500}
        arrow={true}
        disabled={disabled}
    >
        {children}
    </Tooltip>
);

ActionButtonTooltip.propTypes = {
    disabled: PropTypes.bool,
    children: PropTypes.node,
    title: PropTypes.string
};

export const PredicateRowActions = ({ predicateUuid, canReorder, dragHandleProps, canAdd }) => {
    const { setEditing, setDeleting } = React.useContext(RuleEditorContext);

    return (
        <ActionsContainer>
            <CompactButtonRow>
                <ActionButtonTooltip title="Click and drag to reorder predicates">
                    <DraggableButton
                        disabled={!canReorder}
                        {...dragHandleProps.attributes}
                        {...dragHandleProps.listeners}
                        isdragging={dragHandleProps.isDragging?.toString() ?? 'false'}
                    >
                        <IconMenuOrder color={'#555555'} size={ICON_SIZE} />
                        {/* <ButtonIcon icon={`drag_handle`} size={ICON_SIZE} /> */}
                    </DraggableButton>
                </ActionButtonTooltip>
                <ActionButtonTooltip title="Edit predicate">
                    <Button onClick={() => setEditing(predicateUuid)}>
                        <ButtonIcon icon={`edit`} intent={`brand`} size={ICON_SIZE} />
                    </Button>
                </ActionButtonTooltip>
                <ActionButtonTooltip title="Delete predicate">
                    <Button onClick={() => setDeleting(predicateUuid)}>
                        <ButtonIcon icon={`delete`} intent={`danger`} size={ICON_SIZE} />
                    </Button>
                </ActionButtonTooltip>

                {canAdd ? (
                    <ActionButtonTooltip title="Create child predicate">
                        <NewPredicateButton showLabel={false} parentPredicateUuid={predicateUuid} />
                    </ActionButtonTooltip>
                ) : (
                    <ActionButtonTooltip disabled={true}>
                        <InvisibleButton>
                            <ButtonIcon icon={`add`} size={ICON_SIZE} />
                        </InvisibleButton>
                    </ActionButtonTooltip>
                )}
            </CompactButtonRow>
        </ActionsContainer>
    );
};

export default PredicateRowActions;

PredicateRowActions.propTypes = {
    predicateUuid: PropTypes.string,
    canReorder: PropTypes.bool,
    canAdd: PropTypes.bool,
    dragHandleProps: PropTypes.object
};
